module.exports = __webpack_public_path__ + "static/025-6d95dc889c43e6d501570b3da2ef20e8.jpg";